<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="showNewBookingDialog" id="new-booking-dialog">
      <md-dialog-title>Add a new Booking</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createBooking)">
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <h6>Lead Booker</h6>
              <customer-dropdown v-model="booking.user_id" />
            </div>

            <div class="md-layout-item md-size-50">
              <h6>Currency</h6>
              <md-radio v-model="booking.currency" value="gbp">GBP</md-radio>
              <md-radio v-model="booking.currency" value="eur">EUR</md-radio>
              <md-radio v-model="booking.currency" value="usd">USD</md-radio>
            </div>
          </div>

          <md-dialog-actions>
            <md-button class="md-primary" @click="cancel">Cancel</md-button>
            <md-button type="submit" class="md-primary">Create</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";
import customerApi from "@/services/api/customer";
import CustomerDropdown from "@/components/Handi/Users/CustomerDropdown.vue";

export default {
  name: "BookingCreateDialog",

  props: ["showNewBookingDialog", "departure"],

  components: {
    CustomerDropdown
  },

  data() {
    return {
      booking: {
        currency: "gbp",
        user_id: null,
        departure_id: null
      },
      customers: []
    };
  },

  methods: {
    cancel() {
      this.$emit("cancelled");
    },

    createBooking() {
      this.booking.departure_id = this.departure.id;
      bookingApi.createBooking(this.booking).then(response => {
        this.$emit("created", response.data);
      });
    }
  },

  mounted() {
    customerApi.getCustomers().then(response => {
      this.customers = response.data;
    });
  }
};
</script>
<style lang="scss" scoped>
#new-booking-dialog .md-dialog-container {
  max-width: 768px;
  min-width: 768px;
  width: 768px;
}
</style>
